var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6641,
    cy: 30.5,
    r: 30,
    fill: "#059003",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0311 19.148L36.0311 17.573C33.3971 16.1915 32.0801 15.5 30.6641 15.5C29.2481 15.5 27.9311 16.19 25.2971 17.573L24.8156 17.8265L38.2001 25.475L44.2241 22.46C43.2551 21.362 41.6921 20.5415 39.0311 19.145M45.2861 24.446L39.2891 27.446V32C39.2891 32.2984 39.1705 32.5845 38.9596 32.7955C38.7486 33.0065 38.4624 33.125 38.1641 33.125C37.8657 33.125 37.5795 33.0065 37.3686 32.7955C37.1576 32.5845 37.0391 32.2984 37.0391 32V28.571L31.7891 31.196V45.356C32.8661 45.0875 34.0916 44.4455 36.0311 43.427L39.0311 41.852C42.2576 40.1585 43.8716 39.3125 44.7686 37.79C45.6641 36.269 45.6641 34.3745 45.6641 30.59V30.4145C45.6641 27.575 45.6641 25.799 45.2861 24.446ZM29.5391 45.356V31.196L16.0421 24.446C15.6641 25.799 15.6641 27.575 15.6641 30.4115V30.587C15.6641 34.3745 15.6641 36.269 16.5596 37.79C17.4566 39.3125 19.0706 40.16 22.2971 41.8535L25.2971 43.427C27.2366 44.4455 28.4621 45.0875 29.5391 45.356ZM17.1041 22.4615L30.6641 29.2415L35.7806 26.684L22.4516 19.067L22.2971 19.148C19.6376 20.543 18.0731 21.3635 17.1041 22.463",
    fill: "#059003"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalorder);
export default __webpack_public_path__ + "static/media/totalorder.7c9066ed1a38af43f3a9d8a1ea7ed275.svg";
export { ForwardRef as ReactComponent };